/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Box,
    Button,
    IconButton
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import SearchBar from "../../components/SearchBar";
import StoreOutlinedIcon from "@mui/icons-material/StoreOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import AddContractData from "../../Modals/addcontractdata";
import SwitchToggle from "../../components/SwitchToggle";
import RejectReasonModal from "../../Modals/rejectReason";

const VendorContracts = () => {
    const navigate = useNavigate();
    const [searchTerm, setSearchTerm] = useState("");

    // Sample campaign data
    const vendorColumns = [
        "Vendor",
        "Contact",
        "Type",
        "Risk",
        "Suspend",
        "Actions",
    ];
    const [vendorData, setVendorData] = useState([
        {
            id: "VND-001",
            name: "Fashion House Dubai",
            email: "contact@fashionhouse.ae",
            phone: "+971501234567",
            type: "Fashion",
            status: "Active",
            health: 92.5,
            tier: "Enterprise",
            revenue: "AED 1,250,000",
            suspended: false,
            risk: "Low",
        },
        {
            id: "VND-002",
            name: "TechGadgets UAE",
            email: "info@techgadgets.ae",
            phone: "+971502345678",
            type: "Electronics",
            status: "Active",
            health: 78.3,
            tier: "Pro",
            revenue: "AED 456,000",
            suspended: false,
            risk: "Medium",
        },
        {
            id: "VND-003",
            name: "Home Essentials",
            email: "sales@homeessentials.ae",
            phone: "+971503456789",
            type: "Home & Garden",
            status: "Active",
            health: 85.1,
            tier: "Pro",
            revenue: "AED 320,000",
            suspended: true,
            risk: "High",
        },
    ]);
    const [openModal, setOpenModal] = useState(false);
    const handleCloseModal = () => {
        setOpenModal(false);
    };
    const [enabled, setEnabled] = useState(false);
    const [open1, setOpen1] = useState(false);
    const handleCloseModal1 = () => {
        setOpen1(false);
    };
    return (
        <>
            <div className="main_title">
                <h1>Vendor Contracts</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Vendor Contracts
                </p>
            </div>

            <div className="stats_boxes gap_m">

                {/* Total Vendors */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            42
                            <p>Total Vendors</p>
                        </h2>
                        <figure className="blue">
                            <StoreOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                  
                </a>

                {/* Total Contracts */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            130
                            <p>Total Contracts</p>
                        </h2>
                        <figure className="sucess">
                            <DescriptionOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
               
                </a>

             

                {/* Expiring Contracts */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            6
                            <p>Expired Contracts</p>
                        </h2>
                        <figure className="error">
                            <ReportProblemOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                 
                </a>

                {/* High-Risk Contracts */}
                <a className="cards">
                    <div className="data_top">
                        <h2>
                            5
                            <p>High-Risk Contracts</p>
                        </h2>
                        <figure className="warning">
                            <WarningAmberOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                 
                </a>

            </div>
            <div className="table_flex mt_20">
                <div className="lt">

                    <div className="cards ">
                        <div className="table_header">
                            <div className="left_s">
                                <Box className="search_box">
                                    <SearchBar
                                        searchTerm={searchTerm}
                                        setDebouncedSearchTerm={setSearchTerm}
                                        placeholder="Search vendors..."
                                    />
                                </Box>
                                <div className="form"><div className="control_group">
                                    <input type="date" />
                                </div></div>
                            </div>
                            <div className="right_s">
                                <Button className="btn btn_primary sm" onClick={() => navigate("/vendor-comtracts/edit")}>Add Contract Details</Button>
                            </div>
                        </div>



                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {vendorColumns.map((col, i) => (
                                            <TableCell key={i}>{col}</TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {vendorData.map((vendor, index) => (
                                        <TableRow key={vendor.id} hover>
                                            <TableCell>
                                                <b>{vendor.name}</b><br />
                                                <small>{vendor.id}</small>
                                            </TableCell>

                                            <TableCell>
                                                {vendor.email}<br />
                                                <small>{vendor.phone}</small>
                                            </TableCell>

                                            <TableCell>{vendor.type}</TableCell>

                                            <TableCell>
                                                <Box
                                                    sx={{
                                                        padding: "4px 12px",
                                                        borderRadius: "6px",
                                                        fontSize: "13px",
                                                        fontWeight: 500,
                                                        width: "fit-content",
                                                        backgroundColor: vendor.risk === 'High' ? '#FFF1F1' : vendor.risk === 'Medium' ? '#FFF4DE' : '#DCFFCC',
                                                        color: vendor.risk === 'High' ? '#ff0000' : vendor.risk === 'Medium' ? '#d4af37' : '#10b981',
                                                        border: `1px solid ${vendor.risk === 'High' ? '#ffe4e4' : vendor.risk === 'Medium' ? '#ffe8cc' : '#d1ead1'}`,
                                                    }}
                                                >
                                                    {vendor.risk}
                                                </Box>
                                            </TableCell>

                                            <TableCell>
                                                <SwitchToggle
                                                    checked={enabled}
                                                    onChange={(e) => {
                                                        const isChecked = e.target.checked;
                                                        setEnabled(isChecked);
                                                        if (isChecked) {
                                                            setOpen1(true);
                                                        }
                                                    }}
                                                />
                                            </TableCell>


                                            <TableCell>
                                                <div className="table_actions v2">
                                                    <IconButton onClick={() => navigate("view")}>
                                                        <img src="/static/images/eye_icon.svg" />
                                                    </IconButton>
                                             
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
                <div className="rt">
                    <div className="ai_panel">
                        <h4>Actions and AI Contract Insights</h4>

                        <div className="ai_alert warning">
                            <span className="icon">⚠️</span>
                            <p>
                                <b>7 SKUs</b> need immediate attention
                            </p>
                        </div>

                        <div className="ai_alert danger">
                            <span className="icon">⛔</span>
                            <p>
                                <b>3 SKUs</b> have zero sales in 30 days
                            </p>
                        </div>

                        <small className="ai_update">
                            Next updated ETA: <b>May 5, 2024</b>
                        </small>

                        <div className="ai_sku_list">
                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_002</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>

                            <div className="ai_sku_row">
                                <div className="ai_sku_info">
                                    <h5>#PRD_010</h5>
                                    <p>Likely to go out of stock by May</p>
                                </div>
                                <button className="ai_action_btn">Actions ▾</button>
                            </div>
                        </div>

                        {/* <div className="ai_create">
                                    + Create AI Insights
                                </div> */}
                    </div>
                </div>
            </div>
            <RejectReasonModal
                open={open1}
                onClose={handleCloseModal1}
                setOpen={setOpen1}
            />
        </>
    );
};

export default VendorContracts;
